import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const auth = getAuth();
    const location = useLocation();
    const [loading, setLoading] = useState(true); // Track loading state
    const [isAuthenticated, setIsAuthenticated] = useState(false); // Track authentication status

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setIsAuthenticated(!!user); // Update authentication status
            setLoading(false); // Set loading to false once resolved
        });

        return () => unsubscribe(); // Cleanup subscription
    }, [auth]);

    if (loading) {
        return <></>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/signIn" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
